import CardEstresse from "./CardEstresse"
import { numBR } from "./lib/realizado"
import { pilaresPremium, scorePremium } from "./lib/constantes"
import { vereditoSeparacao } from "./lib/veredito"

export default function TabPremium3({
  AVISO_DENOM,
  acertosDca,
  dcaAmount,
  dcaBestTarget,
  dcaEtf,
  enriched,
  etfEnriched,
  generatePremium3Analysis,
  handleSubscribe3,
  isPremium3,
  loadingPremium3,
  manageSubscription,
  medAbre,
  medStub,
  portfolioStats,
  portfolioTechnical,
  premium3Analysis,
  prices,
  s,
  setDcaAmount,
  setDcaBestTarget,
  setDcaEtf,
  setMedAberta,
  setTranslatedPremium3,
  setTranslatingPremium3,
  stress,
  techTicker,
  technical,
  totalValue,
  translateAnalysis,
  translatedPremium3,
  translatingPremium3,
}) {
  return (
        <div>
          {!isPremium3 ? (
            <div style={{...s.card, textAlign:"center", padding:24, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)"}}>
              <div style={{fontSize:48, marginBottom:8}}>🧠</div>
              <h2 style={{color:"#c084fc", fontSize:22, fontWeight:"bold", margin:"0 0 8px 0"}}>ClawETF Premium 3</h2>
              <p style={{color:"#e9d5ff", fontSize:13, marginBottom:20, lineHeight:1.6}}>Análise interpretativa completa gerada por Inteligência Artificial — igual ao que um analista sênior de investimentos faria.</p>
              {[
                "🏆 ClawETF Premium Score™ — score de qualidade do portfólio","🧮 DCA Efficiency Score™ — timing ideal de aportes","🧠 Interpretação completa de todos os indicadores",
                "📊 Análise de risco em linguagem acessível",
                "🎯 Recomendações personalizadas por Claude AI",
                "📈 Comparação com benchmarks explicada",
                "🎲 Interpretação do Monte Carlo",
                "💡 Perspectiva de mercado e contexto",
                "💠 Chat CLAW AI — pergunte sobre sua carteira quando quiser",
                "🧪 Teste de estresse — escadas por fator, cenários combinados e replay de crises que aconteceram",
                "🔎 O mapa confere? — o replay auditado contra uma segunda fonte de preço, com o erro típico declarado",
                "🛡️ Risk Contribution — quanto cada ativo pesa no risco, que não é o peso em dinheiro",
                "🎯 Driver Attribution e heatmap — quem moveu a carteira hoje e quanto",
                "🏆 Melhor destino para o próximo aporte — ranking dos seus ativos pela melhora no preço médio",
                "📐 Premium Score aberto em cinco notas — estrutura, risco, diversificação, momentum e cenários",
                "🌐 Análise traduzida para inglês"
              ].map((f,i) => (
                <div key={i} style={{display:"flex", alignItems:"center", gap:8, marginBottom:8, textAlign:"left"}}>
                  <span style={{color:"#22c55e"}}>✓</span>
                  <span style={{color:"#f3e8ff", fontSize:13}}>{f}</span>
                </div>
              ))}
              <p style={{color:"#9ca3af", fontSize:11, lineHeight:1.5, margin:"0 0 4px 0", textAlign:"left"}}>Cada score desta aba é registrado e conferido trinta dias depois — e o resultado fica no app, inclusive quando é ruim.</p>
              <div style={{margin:"20px 0 16px"}}>
                <span style={{color:"#c084fc", fontSize:28, fontWeight:"bold"}}>$29,99</span>
                <span style={{color:"#a855f7", fontSize:14}}>/mês</span>
              </div>
              <div style={{display:"flex", gap:8}}>
                <button onClick={() => handleSubscribe3("USD")} style={{...s.addBtn, flex:1, background:"linear-gradient(135deg, #7c3aed, #a855f7)", fontSize:13}}>
                  💳 $29,99/mês
                </button>
                <button onClick={() => handleSubscribe3("BRL")} style={{...s.addBtn, flex:1, background:"linear-gradient(135deg, #059669, #7c3aed)", fontSize:13}}>
                  💳 R$149,90/mês
                </button>
              </div>
            </div>
          ) : (
            <div>
              <div style={{...s.card, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(192,132,252,0.2)"}}>
                <p style={{color:"#c084fc", fontSize:12, margin:"0 0 8px 0"}}>🧠 Premium 3 Ativo</p>
                <p style={{color:"#9ca3af", fontSize:12, marginBottom:12, lineHeight:1.5}}>
                  {portfolioStats && !portfolioStats?.error
                    ? "As métricas da 💎 já estão carregadas. Pode gerar a análise."
                    : "Para gerar a análise completa, primeiro execute a análise na aba 💎 Premium 2, depois volte aqui."}
                </p>
                <button onClick={manageSubscription} style={{...s.addBtn, backgroundColor:"#1f2937", marginBottom:8, fontSize:13}}>⚙️ Gerenciar Assinatura</button>
                <button onClick={generatePremium3Analysis} style={{...s.addBtn, background:"linear-gradient(135deg, #7c3aed, #a855f7)"}} disabled={loadingPremium3}>
                  {loadingPremium3 ? "⏳ Gerando análise com Claude..." : "🧠 Gerar Análise Completa com IA"}
                </button>
              </div>
              {premium3Analysis && (
                <div style={s.card}>
                  <p style={s.cardTitle}>🧠 Análise Completa — Claude AI</p>
                  <div style={{color:"#e2e8f0", fontSize:13, lineHeight:1.8, whiteSpace:"pre-wrap"}}>{translatedPremium3 || premium3Analysis}</div>
                  <div style={{marginTop:8}}>
                    {!translatedPremium3 ? (
                      <button
                        onClick={() => translateAnalysis(premium3Analysis, setTranslatedPremium3, setTranslatingPremium3)}
                        disabled={translatingPremium3}
                        style={{...s.addBtn, fontSize:12, padding:"6px 12px", marginBottom:0, background:"#1f2937"}}
                      >
                        {translatingPremium3 ? "⏳ Translating..." : "🌐 Translate to English"}
                      </button>
                    ) : (
                      <button
                        onClick={() => setTranslatedPremium3("")}
                        style={{...s.addBtn, fontSize:12, padding:"6px 12px", marginBottom:0, background:"#1f2937"}}
                      >
                        🔄 Show Original
                      </button>
                    )}
                  </div>
                </div>
              )}
            {etfEnriched.length > 0 && (
              <div style={{...s.card, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(192,132,252,0.2)"}}>
                <p style={{...s.cardTitle, color:"#c084fc"}}>🗺️ Heatmap do Portfólio</p>
                <p style={{color:"#9ca3af", fontSize:11, marginBottom:12}}>Tamanho = peso na carteira · Cor = performance hoje</p>
                <div style={{display:"flex", flexWrap:"wrap", gap:4}}>
                  {[...enriched].sort((a,b) => b.value - a.value).map((p,i) => {
                    const total = etfEnriched.reduce((s,x) => s + x.value, 0)
                    const pct = total > 0 ? (p.value / total) : 0
                    const size = Math.round(60 + pct * 140 * etfEnriched.length * 0.4)
                    const chg = p.dailyChange || 0
                    const intensity = Math.min(Math.abs(chg) / 5, 1)
                    const bg = chg >= 0 ? `rgba(34,197,94,${0.15 + intensity * 0.6})` : `rgba(239,68,68,${0.15 + intensity * 0.6})`
                    const border = chg >= 0 ? "#22c55e" : "#ef4444"
                    return (
                      <div key={i} style={{width:size, height:size, backgroundColor:bg, border:`1px solid ${border}`, borderRadius:8, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:4}}>
                        <span style={{color:"#e2e8f0", fontSize:size>90?13:10, fontWeight:"bold"}}>{p.symbol}</span>
                        <span style={{color:chg>=0?"#22c55e":"#ef4444", fontSize:size>90?12:9}}>{chg>=0?"+":""}{chg.toFixed(2)}%</span>
                        <span style={{color:"#6b7280", fontSize:9}}>${p.value.toFixed(0)}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            )}

            {etfEnriched.length > 0 && (() => {
              const totalDailyAbs = etfEnriched.reduce((s, p) => s + Math.abs(p.dailyPnl || 0), 0)
              const sorted = [...etfEnriched].sort((a, b) => Math.abs(b.dailyPnl || 0) - Math.abs(a.dailyPnl || 0))
              return (
                <div style={{...s.card, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(192,132,252,0.2)"}}>
                  <p style={{...s.cardTitle, color:"#c084fc"}}>🎯 Driver Attribution</p>
                  <p style={{color:"#9ca3af", fontSize:11, marginBottom:12}}>Quem mais impactou a carteira hoje</p>
                  {sorted.map((p, i) => {
                    const pnl = p.dailyPnl || 0
                    const pct = totalDailyAbs > 0 ? Math.abs(pnl) / totalDailyAbs * 100 : 0
                    const barColor = pnl >= 0 ? "#22c55e" : "#ef4444"
                    return (
                      <div key={i} style={{marginBottom:10}}>
                        <div style={{display:"flex", justifyContent:"space-between", gap:8, marginBottom:3}}>
                          <span style={{color:"#e2e8f0", fontSize:12, fontWeight:"bold"}}>{p.symbol}</span>
                          <div style={{display:"flex", gap:8}}>
                            <span style={{color: pnl >= 0 ? "#22c55e" : "#ef4444", fontSize:12}}>{pnl >= 0 ? "+" : ""}${pnl.toFixed(2)}</span>
                            <span style={{color:"#6b7280", fontSize:11}}>{pct.toFixed(1)}%</span>
                          </div>
                        </div>
                        <div style={{backgroundColor:"#1f2937", borderRadius:4, height:6}}>
                          <div style={{width:pct+"%", backgroundColor:barColor, borderRadius:4, height:6}}/>
                        </div>
                      </div>
                    )
                  })}
                  <div style={{borderTop:"1px solid #1f2937", paddingTop:8, marginTop:4}}>
                    <p style={{color:"#6b7280", fontSize:10, margin:0}}>
                      Top 2 drivers: {sorted[0]?.symbol} ({(sorted[0]?.dailyPnl||0) >= 0 ? "alta" : "queda"}) + {sorted[1]?.symbol} ({(sorted[1]?.dailyPnl||0) >= 0 ? "alta" : "queda"}) explicam {sorted.slice(0,2).reduce((s,p) => s + (totalDailyAbs > 0 ? Math.abs(p.dailyPnl||0)/totalDailyAbs*100 : 0), 0).toFixed(0)}% do movimento
                    </p>
                  </div>
                </div>
              )
            })()}

            {etfEnriched.length > 0 && (() => {
              const totalVal = etfEnriched.reduce((s,p) => s + (p.value||0), 0)
              const sorted2 = [...etfEnriched].sort((a,b) => (b.value||0) - (a.value||0))
              return (
                <div style={{...s.card, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(192,132,252,0.2)"}}>
                  <p style={{...s.cardTitle, color:"#c084fc"}}>🛡️ Risk Contribution</p>
                  <p style={{color:"#9ca3af", fontSize:11, marginBottom:12}}>Quanto cada ativo pesa no risco total — combina o tamanho da posição com a volatilidade dela. Por isso o percentual aqui difere do peso em dinheiro.</p>
                  <p style={{color:"#4b5563", fontSize:9, margin:"4px 0 8px 0", lineHeight:1.5}}>⚡ compara o movimento de hoje com o risco que o ativo ocupa: perto de 1,00 ele variou na proporção esperada; acima, mais; abaixo, menos.</p>
                  {[...sorted2].sort((a,b) => {
                    const _s = portfolioStats?.position_stats || {}
                    const vA = parseFloat(_s[a.symbol]?.volatility) || 0
                    const vB = parseFloat(_s[b.symbol]?.volatility) || 0
                    return ((b.value||0)*vB) - ((a.value||0)*vA)
                  }).map((p, i) => {
                    // antes esta tela mostrava so o PESO rotulado como "risco".
                    // agora pondera pela volatilidade de cada ativo (position_stats)
                    const _st = portfolioStats?.position_stats || {}
                    const _volDe = x => parseFloat(_st[x.symbol]?.volatility) || 0
                    const _totRisco = etfEnriched.reduce((a,x) => a + (totalVal>0?(x.value||0)/totalVal*100:0) * _volDe(x), 0)
                    const peso = totalVal > 0 ? (p.value||0) / totalVal * 100 : 0
                    const vol = _volDe(p)
                    const pct = _totRisco > 0 ? peso * vol / _totRisco * 100 : peso
                    const totalDailyAbsAll = etfEnriched.reduce((s,x)=>s+Math.abs(x.dailyPnl||0),0)
                    const driverPct = totalDailyAbsAll > 0 ? Math.abs(p.dailyPnl||0)/totalDailyAbsAll*100 : 0
                    const _base = vol > 0 ? pct : peso
                    const effScore = _base > 0 ? driverPct / _base : 0
                    const effColor = effScore >= 1 ? "#22c55e" : effScore >= 0.5 ? "#fbbf24" : "#ef4444"
                    return (
                      <div key={i} style={{marginBottom:10}}>
                        <div style={{display:"flex", justifyContent:"space-between", gap:8, marginBottom:3}}>
                          <span style={{color:"#e2e8f0", fontSize:12, fontWeight:"bold"}}>{p.symbol}</span>
                          <div style={{display:"flex", gap:8}}>
                            <span style={{color: vol > 0 ? "#a78bfa" : "#6b7280", fontSize:12}}>{vol > 0 ? pct.toFixed(1) + "% risco" : "sem dados"}</span>
                            <span style={{color:"#6b7280", fontSize:10}}>({peso.toFixed(1)}% peso{vol > 0 ? " · vol " + vol.toFixed(0) + "%" : " · volatilidade indisponível"})</span>
                            <span style={{color: effColor, fontSize:10}} title="quanto o ativo entrega de movimento hoje em relacao ao risco que ocupa">{vol > 0 ? "⚡ " + effScore.toFixed(2) : ""}</span>
                          </div>
                        </div>
                        <div style={{backgroundColor:"#1f2937", borderRadius:4, height:6}}>
                          <div style={{width:pct+"%", backgroundColor: effScore >= 1 ? "#22c55e" : effScore >= 0.5 ? "#8b5cf6" : "#ef4444", borderRadius:4, height:6}}/>
                        </div>
                      </div>
                    )
                  })}
                  <div style={{borderTop:"1px solid #1f2937", paddingTop:8, marginTop:4}}>
                    <p style={{color:"#6b7280", fontSize:10, margin:0}}>
                      {(() => {
                        const _s = portfolioStats?.position_stats || {}
                        const _v = x => parseFloat(_s[x.symbol]?.volatility) || 0
                        const _tot = etfEnriched.reduce((a,x) => a + (totalVal>0?(x.value||0)/totalVal*100:0) * _v(x), 0)
                        const _top = [...sorted2].sort((a,b) => ((b.value||0)*_v(b)) - ((a.value||0)*_v(a))).slice(0,2)
                        if (!_tot) return "Concentração indisponível"
                        const _r = _top.reduce((a,x) => a + (totalVal>0?(x.value||0)/totalVal*100:0) * _v(x) / _tot * 100, 0)
                        const _p = _top.reduce((a,x) => a + (totalVal>0?(x.value||0)/totalVal*100:0), 0)
                        return _top.map(x=>x.symbol).join(" + ") + " concentram " + _r.toFixed(0) + "% do risco com " + _p.toFixed(0) + "% do capital"
                      })()}
                    </p>
                  </div>
                </div>
              )
            })()}

            {etfEnriched.length > 0 && portfolioStats && !portfolioStats?.error && (() => {
                const _pp = pilaresPremium(etfEnriched, portfolioStats, prices)
                const { estrutura, risco, diversif, momentum, perspectiva } = _pp
                const _sc = scorePremium(estrutura, risco, diversif, momentum, perspectiva)
                const totalBruto = _sc.bruto
                const _pior = _sc.pior
                const total = _sc.total
                const limitadoPor = total < totalBruto ? _pior.n : null
                const toGrade = s => s >= 90?"A+":s >= 83?"A":s >= 76?"A-":s >= 70?"B+":s >= 63?"B":s >= 56?"B-":s >= 50?"C+":s >= 43?"C":s >= 36?"C-":s >= 30?"D+":s >= 23?"D":"F"
                const scoreColor = total >= 80 ? "#22c55e" : total >= 60 ? "#86efac" : total >= 40 ? "#f59e0b" : total >= 25 ? "#f97316" : "#ef4444"
                const scoreLabel2 = total >= 80 ? "Excelente" : total >= 60 ? "Boa" : total >= 40 ? "Atenção" : total >= 25 ? "Fraca" : "Crítica"
                const cats = [
                  {label:"Estrutura", score:estrutura},
                  {label:"Risco", score:risco},
                  {label:"Diversificação", score:diversif},
                  {label:"Momentum", score:momentum},
                  {label:"Cenários positivos · " + Math.round(parseFloat(portfolioStats?.monte_carlo?.prob_positive) || 0) + "%", score:perspectiva},
                ]
                return (
                  <div style={{...s.card, border:"1px solid rgba(99,102,241,0.3)", background:"linear-gradient(135deg, #0a0a0f, #0d1117)"}}>
                    <p style={{...s.cardTitle, color:"#a78bfa"}}>🏆 ClawETF Premium Score™</p>
                    <div style={{display:"flex", alignItems:"center", gap:16, marginBottom:16}}>
                      <div style={{textAlign:"center"}}>
                        <div style={{fontSize:40, fontWeight:900, color:scoreColor, lineHeight:1}}>{total}</div>
                        <div style={{fontSize:12, color:scoreColor, fontWeight:600}}>{scoreLabel2}</div>
                        <div style={{fontSize:11, color:"#64748b"}}>/ 100</div>
                      </div>
                      <div style={{flex:1}}>
                        {cats.map((c,i) => (
                          <div key={i} style={{display:"flex", justifyContent:"space-between", marginBottom:4, fontSize:12}}>
                            <span style={{color:"#94a3b8"}}>{c.label}</span>
                            <span style={{color: c.score>=83?"#22c55e":c.score>=56?"#86efac":c.score>=43?"#f59e0b":c.score>=23?"#f97316":"#ef4444", fontWeight:700}}>{toGrade(c.score)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    {limitadoPor && <div style={{fontSize:11, color:"#f59e0b", marginBottom:4, lineHeight:1.5}}>⚠️ A média daria {totalBruto}, mas o score foi limitado a {total} pelo pilar {limitadoPor}. Um pilar fraco não é compensado pelos outros.</div>}
                    <div style={{fontSize:11, color:"#64748b"}}>Estrutura 25% · Risco 25% · Diversificação 20% · Momentum 15% · Cenários positivos 15%</div>
                  </div>
                )
              })()}

            {etfEnriched.length > 0 && (
              <div style={{...s.card, background:"linear-gradient(135deg, #0a0a0f, #1a0a2e)", border:"1px solid rgba(192,132,252,0.2)"}}>
                <p style={{...s.cardTitle, color:"#c084fc"}}>🧮 CLAW DCA Efficiency Score™ </p>
                <p style={{color:"#9ca3af", fontSize:11, marginBottom:8}}>Simule o impacto de um novo aporte no seu preço médio</p>
                <p style={{color:"#6b7280", fontSize:10, marginBottom:8, lineHeight:1.5}}>{"Nota de 0 a 100: a melhora do preço médio pesa 4/9, o momento pelo RSI 3/9 e o tamanho do aporte 2/9."}</p>
                <div style={{marginBottom:12}}>
                  <p style={{color:"#6b7280", fontSize:11, marginBottom:4}}>Valor do aporte (USD):</p>
                  <input type="text" inputMode="decimal" value={dcaAmount} onChange={e => setDcaAmount(e.target.value)} placeholder="Ex: 57" style={{width:"100%", backgroundColor:"#1f2937", border:"1px solid #374151", borderRadius:8, padding:"8px 10px", color:"#e2e8f0", fontSize:13, boxSizing:"border-box"}} />
                </div>
                {dcaAmount > 0 && (
                  <div style={{marginBottom:12}}>
                    <button onClick={() => {
                      const results = etfEnriched.map(p => {
                        const oldDca = p.avg_price || 0
                        const oldQty = p.quantity || 0
                        const cp = p.currentPrice || 0
                        const nq = cp > 0 ? numBR(dcaAmount) / cp : 0
                        const newDca = (oldQty + nq) > 0 ? (oldQty * oldDca + numBR(dcaAmount)) / (oldQty + nq) : oldDca
                        const imp = oldDca > 0 ? ((oldDca - newDca) / oldDca * 100) : 0
                        const tv = etfEnriched.reduce((s,x)=>s+(x.value||0),0)
                        const portfolioImpact = tv > 0 ? (numBR(dcaAmount) / tv * 100) : 0
                        const rsi = (portfolioTechnical[p.symbol]?.rsi) || (technical && techTicker.trim() === p.symbol.trim() && technical.rsi) || null
                        const timingScore = !rsi ? 15 : rsi<25?30:rsi<35?22:rsi<45?15:rsi<55?10:5
                        const impScore = Math.min(40, imp * 8)
                        const portScore = Math.min(20, portfolioImpact * 2)
                        // o card anuncia escala 0-100, mas aportar num ativo em lucro gerava
                        // nota negativa (ORCL saiu -39)
                        const eff = Math.max(0, Math.min(100, Math.round((impScore + portScore + timingScore) * 100 / 90)))
                        return { symbol: p.symbol, eff }
                      }).sort((a,b) => b.eff - a.eff)
                      setDcaBestTarget(results)
                    }} style={{...s.addBtn, background:"linear-gradient(135deg, #7c3aed, #a855f7)", fontSize:12, padding:"8px 14px"}}>
                      {"🏆 Melhor destino para $" + dcaAmount} 
                    </button>
                    {dcaBestTarget.length > 0 && (
                      <div style={{marginTop:8, backgroundColor:"#0f172a", borderRadius:8, padding:10, border:"1px solid rgba(192,132,252,0.2)"}}>
                        {dcaBestTarget.map((r,i) => (
                          <div key={r.symbol} style={{display:"flex", justifyContent:"space-between", marginBottom:4}}>
                            <span style={{color: i===0?"#f59e0b":"#9ca3af", fontSize:12}}>{(() => {
                              // medalha por PONTUACAO, nao por posicao no array:
                              // empatados recebem a mesma medalha
                              const pos = dcaBestTarget.filter(x => x.eff > r.eff).length
                              const emp = dcaBestTarget.filter(x => x.eff === r.eff).length > 1
                              return (pos===0?"🥇":pos===1?"🥈":pos===2?"🥉":"  ") + (emp ? "=" : "")
                            })()} {r.symbol}</span>
                            <span style={{color: r.eff>=65?"#22c55e":r.eff>=45?"#f59e0b":"#ef4444", fontSize:12, fontWeight:"bold"}}>{r.eff}/100</span>
                          </div>
                        ))}
                      </div>
                      )}
                  </div>
                )}
                <div style={{marginBottom:8}}>
                  <p style={{color:"#6b7280", fontSize:11, marginBottom:4}}>ETF:</p>
                  <select value={dcaEtf} onChange={e => setDcaEtf(e.target.value)} style={{width:"100%", backgroundColor:"#1f2937", border:"1px solid #374151", borderRadius:8, padding:"8px 10px", color:"#e2e8f0", fontSize:13}}>
                    <option value="">Da minha carteira...</option>
                    {etfEnriched.map(p => <option key={p.symbol} value={p.symbol}>{p.symbol} — DCA ${p.avg_price?.toFixed(2)} · Atual ${p.currentPrice?.toFixed(2)}</option>)}
                  </select>
                </div>
                {dcaEtf && dcaAmount > 0 && (() => {
                  const pos = etfEnriched.find(p => p.symbol === dcaEtf)
                  if (!pos) return null
                  const currentPrice = pos.currentPrice || 0
                  const oldDca = pos.avg_price || 0
                  const oldQty = pos.quantity || 0
                  const oldValue = oldQty * oldDca
                  const newQty = currentPrice > 0 ? numBR(dcaAmount) / currentPrice : 0
                  const newDca = (oldQty + newQty) > 0 ? (oldValue + numBR(dcaAmount)) / (oldQty + newQty) : oldDca
                  const improvement = oldDca > 0 ? ((oldDca - newDca) / oldDca * 100) : 0
                  const portfolioImpact = totalValue > 0 ? (numBR(dcaAmount) / totalValue * 100) : 0
                  const positionImpact = pos.value > 0 ? (numBR(dcaAmount) / pos.value * 100) : 0
                  // mesma formula do ranking, para os dois numeros nunca divergirem
                  const improvementScore = Math.min(40, improvement * 8)
                  const timingScore = (() => {
                    // mesma ordem de resolucao do ranking: o RSI
                    // da analise da carteira primeiro, o do campo
                    // de ticker unico depois. Antes de 10/10/2026
                    // este card so aceitava o segundo e caia no
                    // default 15, divergindo do ranking em ate 15
                    // pontos — no FBTC de hoje, 15 contra 10.
                    const rsi = (portfolioTechnical[dcaEtf]
                      && portfolioTechnical[dcaEtf].rsi)
                      || (technical && techTicker === dcaEtf
                        ? technical.rsi : null)
                    if (!rsi) return 15
                    if (rsi < 25) return 30
                    if (rsi < 35) return 22
                    if (rsi < 45) return 15
                    if (rsi < 55) return 10
                    return 5
                  })()
                  const posImpactScore = Math.min(20, portfolioImpact * 2)
                  // sem o piso o card mostrava -65/100 num score de 0 a 100, e divergia do
                  // ranking, que ja cortava em zero
                  const efficiency = Math.max(0, Math.min(Math.round((improvementScore + timingScore + posImpactScore) * 100 / 90), 100))
                  const effColor = efficiency >= 65 ? "#22c55e" : efficiency >= 45 ? "#f59e0b" : "#ef4444"
                  const effLabel = efficiency >= 65 ? "Excelente" : efficiency >= 45 ? "Razoável" : "Baixa eficiência"
                  return (
                    <div style={{backgroundColor:"#0f172a", borderRadius:10, padding:12, border:"1px solid rgba(192,132,252,0.15)"}}>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>DCA anterior</span>
                        <span style={{color:"#e2e8f0", fontSize:12, fontWeight:"bold"}}>${oldDca.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>DCA novo</span>
                        <span style={{color:"#22c55e", fontSize:12, fontWeight:"bold"}}>${newDca.toFixed(2)}</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>{improvement > 0 ? "Melhora no preço médio" : "Piora no preço médio"}</span>
                        <span style={{color: improvement > 0 ? "#22c55e" : "#ef4444", fontSize:12, fontWeight:"bold"}}>{improvement > 0 ? "+" : ""}{improvement.toFixed(2)}%</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>Impacto carteira</span>
                        <span style={{color:"#38bdf8", fontSize:12}}>{portfolioImpact.toFixed(1)}%</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:8}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>Impacto posição</span>
                        <span style={{color:"#38bdf8", fontSize:12}}>{positionImpact.toFixed(1)}%</span>
                      </div>
                      <div style={{display:"flex", justifyContent:"space-between", marginBottom:12}}>
                        <span style={{color:"#9ca3af", fontSize:12}}>Timing técnico</span>
                        <span style={{color: techTicker === dcaEtf && technical?.rsi ? (technical.rsi < 35 ? "#22c55e" : technical.rsi < 55 ? "#f59e0b" : "#ef4444") : "#6b7280", fontSize:12}}>
                          {techTicker === dcaEtf && technical?.rsi ? (technical.rsi < 25 ? "RSI " + technical.rsi.toFixed(1) + " ✅ Oversold extremo" : technical.rsi < 35 ? "RSI " + technical.rsi.toFixed(1) + " ✅ Oversold" : technical.rsi < 45 ? "RSI " + technical.rsi.toFixed(1) + " ⚠️ Neutro-favorável" : technical.rsi < 60 ? "RSI " + technical.rsi.toFixed(1) + " ⚠️ Neutro" : technical.rsi < 70 ? "RSI " + technical.rsi.toFixed(1) + " 🟡 Neutro-elevado" : "RSI " + technical.rsi.toFixed(1) + " 🔴 Sobrecomprado") : "— Rode aba ⭐ em " + dcaEtf}
                        </span>
                      </div>
                      <div style={{borderTop:"1px solid #1f2937", paddingTop:10, display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                        <div>
                          <p style={{color:"#6b7280", fontSize:10, margin:"0 0 2px 0"}}>Eficiência do aporte</p>
                          <p style={{color:effColor, fontSize:13, margin:0}}>{effLabel}</p>
                        </div>
                        <div style={{textAlign:"center"}}>
                          <p style={{color:effColor, fontSize:28, fontWeight:"bold", margin:0}}>{efficiency}</p>
                          <p style={{color:"#6b7280", fontSize:10, margin:0}}>/100</p>
                        </div>
                      </div>
                      <p style={{color:"#4b5563", fontSize:10, margin:"8px 0 0 0"}}>⚠️ Simulação apenas — não executa nenhuma operação</p>
                    </div>
                  )
                })()}
              </div>
            )}

            </div>
          )}
          {medStub("dca", acertosDca, "🎯 Estar abaixo do preço médio antecipa alta?", () => (
            <div style={s.card}>
              <p style={s.cardTitle}>🎯 Estar abaixo do preço médio antecipa alta?</p>
              {acertosDca.total === 0 ? (
                <p style={{color:"#6b7280", fontSize:12, margin:0, lineHeight:1.5}}>
                  O objetivo "melhorar preço médio" dá a cada ativo uma pontuação de 0 a
                  100, que cresce quanto mais o preço de hoje estiver abaixo do que você
                  pagou em média. Ou seja, a pontuação descreve a sua posição no ativo, não o ativo.
                  O app guarda essa pontuação uma vez por dia e, 30 dias depois, compara
                  quanto renderam os ativos que pontuaram 60 ou mais contra os que pontuaram
                  40 ou menos. A pergunta: um ativo bem abaixo do seu preço médio costuma
                  se recuperar, ou isso não diz nada sobre o que vem pela frente?
                  Ainda não há registros com 30 dias.
                </p>
              ) : (
                <div>
                  {acertosDca.total < 20 && (
                    <p style={{color:"#f59e0b", fontSize:11, margin:"0 0 10px 0", lineHeight:1.5}}>
                      ⚠️ Base pequena ({acertosDca.total}): estes números ainda não separam
                      acerto de sorte. São registro em formação, não medida de desempenho.
                    </p>
                  )}
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                    Nota 60+ (bem abaixo do preço médio): retorno médio em 30 dias{" "}
                    {acertosDca.altoMed === null ? "sem dados" : acertosDca.altoMed.toFixed(1) + "%"}
                    {" "}({acertosDca.altoN}{acertosDca.altoN < 3 ? " — amostra insuficiente" : ""})
                  </p>
                  <p style={{color:"#9ca3af", fontSize:12, margin:"0 0 8px 0"}}>
                    Nota até 40: retorno médio em 30 dias{" "}
                    {acertosDca.baixoMed === null ? "sem dados" : acertosDca.baixoMed.toFixed(1) + "%"}
                    {" "}({acertosDca.baixoN}{acertosDca.baixoN < 3 ? " — amostra insuficiente" : ""})
                  </p>
                  <p style={{color:"#4b5563", fontSize:11, margin:"0 0 8px 0", lineHeight:1.5}}>
                    Linha de base: {acertosDca.baseMed === null ? "sem dados" : acertosDca.baseMed.toFixed(1) + "%"}
                    {" "}sem olhar a nota. Se as faixas não se afastarem disso, estar abaixo do
                    preço médio não antecipa nada — o que não invalida o DCA, que existe para
                    diluir o risco de escolher mal a hora, não para prever alta.
                  </p>
                  {(() => {
                    const _v = vereditoSeparacao(acertosDca, "a nota do DCA")
                    return <p style={{color:_v.cor, fontSize:11, margin:"10px 0 0 0", fontWeight:700}}>{_v.txt}</p>
                  })()}
                  <p style={{color:"#4b5563", fontSize:10, margin:"10px 0 0 0"}}>
                    Base: {acertosDca.total} registros com 30 dias completos{" "}{AVISO_DENOM}
                  </p>
                </div>
              )}
            </div>
          ))}
          <CardEstresse stress={stress} medAbre={medAbre}
            setMedAberta={setMedAberta} s={s} />
        </div>
  )
}
